import React, { useEffect, useState } from 'react';
import '../Login/login.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import LOGO from "../../Assets/images/pngwing.com.png"
import BGVideo from "../../Assets/images/obtimize.avif"
import { toast } from 'react-toastify';
import ApiService from '../../services/apiService';
import { ClipLoader } from 'react-spinners';
// import BGVideo from "../../Assets/images/background.mp4"
import { FaArrowLeft } from "react-icons/fa";

const SignUp = () => {
    let navigate = useNavigate();
    const apiService = new ApiService();

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        userName: '',
        mobileNo: '',
        loginPassword: '',
        confirmLoginPassword: '',
        invitationCode: '',
        withdrawPassword: '',
        confirmWithdrawPassword: ''
    })
    const [AddData, setAddData] = useState({
        username: "",
        email: "",
        mobileNumber: "",
        balance: 0,
        parentId: "",
        reputation: "",
        parentUser: "",
        invitationCode: "",
        status: true,
        memberLevel: 0,
        frozenAmount: 0,
        robSingle: "",
        registrationTime: new Date().toISOString(),
        matchingRange: "",
        paymentPassword: "",
        firstName: "",
        lastName: "",
        widthDrawPassword: "",
        userPassword: "",
        credibility: "",
        withdrawMinimumAmount: 0,
        withdrawMaximumAmount: 0,
        withdrawNeedtoCompleteOrderst: "",
        whethertoAllowroborder: true,
        whethertoallowwithdraw: true,
        numberofdraws: "",
        winningAmount: ""
    })
    const [showPasswords, setShowPasswords] = useState({
        login: false,
        confirmLogin: false,
        withdraw: false,
        confirmWithdraw: false
    })
    const [loader, setLoader] = useState(null);

    const togglePasswordVisibility = (field) => {
        setShowPasswords(prev => ({ ...prev, [field]: !prev[field] }));
    }
    const handleAdminlogin = () => {
        navigate(`/login`);
    }
    const handleRegister = async () => {
        setLoader(true)
        if (!formData?.userName) {
            setLoader(false)
            toast.warning("Enter Email")
            return;
        } else if (!formData?.loginPassword) {
            setLoader(false)
            toast?.warning("Enter Password ")
            return;
        } else if (!formData?.withdrawPassword) {
            setLoader(false)
            toast?.warning("Enter WithDraw Password ")
            return;
        }
        //  else if (!formData?.invitationCode) {
        //     setLoader(false)
        //     toast?.warning("Enter Invitation Code ")
        //     return;
        // }
        const currentDatetimeUTC = new Date().toISOString();
        try {
            let body = {
                username: formData?.userName || "",
                email: formData?.userName,
                mobileNumber: formData?.mobileNo,
                invitationCode: formData?.invitationCode,
                status: true,
                registrationTime: currentDatetimeUTC,
                paymentPassword: formData?.withdrawPassword || "",
                firstName: formData?.firstName || "",
                lastName: formData?.lastName || "",
                widthDrawPassword: formData?.withdrawPassword || "",
                userPassword: formData?.loginPassword,
                matchingRange: "30 to 70",
            }
            const response = await apiService.post('CREATE_GAME_USER', body);
            if (response?.status === 200 || response?.status === 201) {
                // navigate(`/login`);
                navigate(`/`);
                setLoader(false)
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error Creating User:", error);
        }
    }
    const handleBack = () => {
        window.history.back();
    };
    return (
        <div className="BGmain" >
            <video className="bg-video" autoPlay loop muted playsInline>
                <source src={BGVideo} type="video/mp4" />
            </video>
            <div className="container py-5 overflow" >
                <div className='d-flex justify-content-center'>
                    <button class="btn btn-primary  w-25 mb-3" onClick={handleBack}><FaArrowLeft />  Back</button>
                </div>
                <div className='d-flex justify-content-center'>
                    <div className='blackBox p-3 p-lg-5 mx-lg-5 width-50'>
                        <div className='center'>
                            <img src={LOGO} className='logosize' />
                        </div>
                        <div className='bodhead center'>Create Your Account</div>
                        <form>
                            <div class="my-1">
                                <label for="exampleInputEmail1" class="form-label" style={{ color: "#fff" }}>UserName / Email</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.userName}
                                    onChange={(e) => setFormData({ ...formData, userName: e.target.value })}
                                />
                            </div>
                            <div class="d-flex gap-3">
                                <div class="my-1 w-50">
                                    <label for="exampleInputEmail1" class="form-label" style={{ color: "#fff" }}>First Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.firstName}
                                        onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                                    />
                                </div>
                                <div class="my-1 w-50">
                                    <label for="exampleInputEmail1" class="form-label" style={{ color: "#fff" }}>Last Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formData.lastName}
                                        onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div class="my-1">
                                <label for="exampleInputEmail1" class="form-label" style={{ color: "#fff" }}>Mobile No.</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.mobileNo}
                                    onChange={(e) => setFormData({ ...formData, mobileNo: e.target.value })}
                                />
                            </div>
                            <div class="d-flex gap-3">
                                <div class="mb-1 w-50">
                                    <label for="exampleInputPassword1" class="form-label" style={{ color: "#fff" }}>Login Password</label>
                                    <div className="input-group">
                                        <input
                                            type={showPasswords.login ? "text" : "password"}
                                            className="form-control"
                                            value={formData.loginPassword}
                                            onChange={(e) => setFormData({ ...formData, loginPassword: e.target.value })}
                                        />
                                        <span className="input-group-text" onClick={() => togglePasswordVisibility('login')}>
                                            {showPasswords.login ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>
                                <div class="mb-1 w-50">
                                    <label for="exampleInputPassword1" class="form-label" style={{ color: "#fff" }}>Confirm Password</label>
                                    <div className="input-group">
                                        <input
                                            type={showPasswords.confirmLogin ? "text" : "password"}
                                            className="form-control"
                                            value={formData.confirmLoginPassword}
                                            onChange={(e) => setFormData({ ...formData, confirmLoginPassword: e.target.value })}
                                        />
                                        <span className="input-group-text" onClick={() => togglePasswordVisibility('confirmLogin')}>
                                            {showPasswords.confirmLogin ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="my-1">
                                <label for="exampleInputEmail1" class="form-label" style={{ color: "#fff" }}>Invitation Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.invitationCode}
                                    onChange={(e) => setFormData({ ...formData, invitationCode: e.target.value })}
                                />
                            </div>
                            <div className='smallhead center' style={{ textDecoration: "none" }}>Withdrawal Password</div>
                            <div class="d-flex gap-3">
                                <div class="my-1 w-50">
                                    <label for="exampleInputPassword1" class="form-label" style={{ color: "#fff" }}>Withdraw Password</label>
                                    <div className="input-group">
                                        <input
                                            type={showPasswords.withdraw ? "text" : "password"}
                                            className="form-control"
                                            value={formData.withdrawPassword}
                                            onChange={(e) => setFormData({ ...formData, withdrawPassword: e.target.value })}
                                        />
                                        <span className="input-group-text" onClick={() => togglePasswordVisibility('withdraw')}>
                                            {showPasswords.withdraw ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>
                                <div class="my-1 w-50">
                                    <label for="exampleInputPassword1" class="form-label" style={{ color: "#fff" }}>Confirm Password</label>
                                    <div className="input-group">
                                        <input
                                            type={showPasswords.confirmWithdraw ? "text" : "password"}
                                            className="form-control"
                                            value={formData.confirmWithdrawPassword}
                                            onChange={(e) => setFormData({ ...formData, confirmWithdrawPassword: e.target.value })}
                                        />
                                        <span className="input-group-text" onClick={() => togglePasswordVisibility('confirmWithdraw')}>
                                            {showPasswords.confirmWithdraw ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </form>
                        {loader === true ?
                            <button class="btn btn-scondary center w-100 btn-lg " type="button">
                                <ClipLoader color='#fff' />
                            </button>
                            :
                            <button type="submit" class="btn mt-2 btn-primary" onClick={handleRegister}>Register Now</button>
                        }
                        <div className='smallhead center pt-2' onClick={handleAdminlogin}>Login</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignUp;
